/**
 * Sensor bridge — abstracts the difference between mock sensor (browser)
 * and native sensor plugin (Android).
 */

import type { PresenceEvent } from '@/types';
import { startMockSensor, stopMockSensor, addPresenceListener } from './mock-sensor';

// On Tizen OS the mmWave sensor is connected via a serial-over-USB
// adapter and communicated with through a native app bridge or
// WebSocket. Until that bridge is implemented the mock sensor is used.
// To add real sensor support: implement a WebSocket/WebSerial listener
// in place of mock-sensor.ts and set isNativeSensor = true.
const isNativeSensor = false;

export function startSensor(): void {
  if (isNativeSensor) {
    console.log('[SensorBridge] Native sensor not implemented yet');
  } else {
    startMockSensor();
  }
}

export function stopSensor(): void {
  if (isNativeSensor) {
    // TODO: native sensor stop
  } else {
    stopMockSensor();
  }
}

export function onPresenceChange(callback: (event: PresenceEvent) => void): () => void {
  if (isNativeSensor) {
    // TODO: native sensor listener
    return () => {};
  } else {
    return addPresenceListener(callback);
  }
}
